/**
 * useSessionModelType
 *
 * Derives the current model type (RouteIdentifier) from `useLocation()`
 * pathname. Falls back to the Redux session value for routes that do not
 * include a model segment.
 */
import { useAppSelector } from '@/store/hooks';
import { useLocation } from '@/routing/hooks';
import { getRouteIdentifierFromPath, getValidatedModelPath } from '@/routing/lib';
import { selectModelType } from '@/store/slices/sessionSlice';
export const useSessionModelType = () => {
    const { pathname } = useLocation();
    const modelPath = getValidatedModelPath(pathname);
    const modelTypeFromUrl = modelPath ? getRouteIdentifierFromPath(modelPath) : undefined;
    // Fallback: read from Redux (keeps parity for pages without model in URL)
    const modelTypeFromRedux = useAppSelector(selectModelType);
    return modelTypeFromUrl !== null && modelTypeFromUrl !== void 0 ? modelTypeFromUrl : modelTypeFromRedux;
};
